import React from 'react';
import { Router, Switch, Route } from 'react-router';
import history from './history';
import routes from './routes/routeConfigurations';
import PrivateRoute from './components/Auth/PrivateRoute';

const generateRoutes = () => routes.map((route, index) => route.private !== false ? <PrivateRoute  key={index} {...route} /> : <Route key={index} {...route} />);

function App() {
  return (
      <Router history={history}>
        <Switch>
        
          {generateRoutes()}

        </Switch>
      </Router>
  );
}

export default App;
